import { createContext, useContext, useEffect, useState } from 'react';
import {
  getFingertipsLinks,
  getHealthSnapshot,
  getHealthSnapshotCoveredMembersHw,
  getOtherCompanyBenefits,
} from '../services/dashboard';
import { getAllCompanies } from '../services/pensionIndex';
import { AuthStore } from './auth';

export type HwDashboardState = {
  healthSnapshot: Array<any>;
  fingertipLinks: Array<any>;
  companiesMessages: Array<any>;
  coveredFamilyMembers: Array<any>;
  otherCompanyBenefits: Array<any>;
};

export const HwDashboardStore = createContext<HwDashboardState>({
  healthSnapshot: [],
  fingertipLinks: [],
  companiesMessages: [],
  coveredFamilyMembers: [],
  otherCompanyBenefits: [],
});

const { Provider } = HwDashboardStore;

export const HwDashboardProvider = ({ children }: any) => {
  const [, , , selectedPersona] = useContext(AuthStore) || [];
  const [hwDashboardState, setHwDashboardState] = useState<HwDashboardState>({
    healthSnapshot: [],
    fingertipLinks: [],
    companiesMessages: [],
    coveredFamilyMembers: [],
    otherCompanyBenefits: [],
  });

  useEffect(() => {
    let healthSnapshot = getHealthSnapshot();
    let fingertipLinks = getFingertipsLinks(selectedPersona);
    let companiesMessages = getAllCompanies(selectedPersona);
    let coveredFamilyMembers = getHealthSnapshotCoveredMembersHw();
    let otherCompanyBenefits = getOtherCompanyBenefits();

    setHwDashboardState({
      healthSnapshot,
      fingertipLinks,
      companiesMessages,
      coveredFamilyMembers,
      otherCompanyBenefits,
    });
  }, [selectedPersona]);

  return <Provider value={hwDashboardState}>{children}</Provider>;
};
